// frontend/src/components/MmiPanel.tsx (or appropriate location)
import React from "react";
import { Button, Group, Stack, Box } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectPostMcbimTrendByKeyArgs,
  selectSingleMcBimMmiValue,
} from "./singleMcbimItemSelectors";
import { MmiBadge } from "../MmiBadge";
import { setMcBimDetailsShowMMiTrendInRedux } from "../../ViewerRedux/viewerSlice";
import { usePostMcbimTrendByKeyQuery } from "../../../openapi";
import { skipToken } from "@reduxjs/toolkit/query";
import { MmiTrendChart } from "./McbimSingleMmiTrendChart";

export const MmiSingleItem: React.FC = () => {
  const dispatch = useAppDispatch();

  const mmi = useAppSelector(selectSingleMcBimMmiValue);
  const { showMmiTrend } = useAppSelector((s) => s.viewer.mcBimDetails);

  const args = useAppSelector(selectPostMcbimTrendByKeyArgs);

  const { data: trendData} = usePostMcbimTrendByKeyQuery(
    args ?? skipToken
  );

  return (
    <Stack gap="xs">
      <Group align="center" gap="xs">
        <MmiBadge value={Number(mmi)} />
        <Button
          size="xs"
          variant="light"
          onClick={() => dispatch(setMcBimDetailsShowMMiTrendInRedux(!showMmiTrend))}
        >
          {showMmiTrend ? "Skjul trend" : "Vis trend"}
        </Button>
      </Group>
      {showMmiTrend && (
        <Box p="md" style={{ border: "1px solid #ddd", borderRadius: "4px" }}>
          {trendData != null && <MmiTrendChart />}
        </Box>
      )}
    </Stack>
  );
};
